import ProspectDetails from "./prospectDetails";

export default ProspectDetails;
